import _ from 'lodash';

import $ from 'jquery';
import BaseWidget from './baseWidget';
import browser from '@openclassrooms/utils/browser';

export default function factory(widgetName, parent, factory) {
  let widget;

  if (_.isPlainObject(parent) && typeof factory === 'undefined') {
    factory = parent;
    parent = BaseWidget;
  }

  if (isJQueryWidget(factory)) {
    widget = createJQueryWidget(widgetName, parent, factory);
  }

  return widget;
}

function isJQueryWidget(factory) {
  return _.isPlainObject(factory);
}

function createJQueryWidget(widgetName, parent, factory) {
  if (!$.widget) {
    if (browser.isBrowser()) {
      // eslint-disable-next-line no-console
      console.warn(
        `Can't create widget '${widgetName}' because jquery ui is not loaded in this context.`
      );
    }
    return;
  }

  try {
    $.widget('OC.' + widgetName, parent, factory);

    $.OC[widgetName].create = function (options, element) {
      let widget;

      if (!_.isPlainObject(options) && !element) {
        element = options;
        options = {};
      }

      widget = new $.OC[widgetName](options, element);
      widget.OC = { name: widgetName };

      return widget;
    };
  } catch (e) {
    // we probably are in a context where a jquery ui widget need
    // to be created but it's not possible
    return { create() {} };
  }

  return $.OC[widgetName];
}
